// extracted by mini-css-extract-plugin
export default {"container":"bN-z","topReviewHeading":"cN-z","criticalReview":"dN-z","favorableReview":"eN-z","vsSeparator":"fN-z"};